// extracted by mini-css-extract-plugin
export default {"root":"S9VlB","container":"_7mGBo","hosts":"O6Jtb","guests":"_9-Ni+","divider":"Y0VxM"};